// extracted by mini-css-extract-plugin
module.exports = {"tagsBox":"tags-module--tags-box--3Oty4","hotTag":"tags-module--hot-tag--3FDq4"};